/*eslint-disable */
import toast from '@/services/toast';
const $ = window.jQuery = require('jquery'); 
import {
  bus
} from '@/main';
export default {
  name: 'trash-paper-popup',
  components: {},
  props: ['trashPaperID'],
  data () {
    return {
       selectedBucketId:null
    }
  },
  computed: {

  },
  created(){
    this.selectedBucketId = this.$route.params.bucketId
  },
  mounted () {
  },
  methods: {
    getPaperPileListAgain(){
      if(this.selectedBucketId){
        this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id:this.selectedBucketId})
      }else{
        this.$store.dispatch('getAllPaperPileFun')
      }
    },
    closeRemoveItemModalFun(){
      bus.$emit('trashPaperStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removePaperInAwerackFun', {id:this.trashPaperID}).then
      ((res) => {
        toast.success(res.data.msg);
        this.getPaperPileListAgain()
        this.closeRemoveItemModalFun()
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
      })
    }
  }
}